import { useState, useEffect } from "react";
import useProfileStore from "../../../store/builders/useProfileStore";

const SocialMedia = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const { profile, fetchProfile, updateProfile, isLoading } = useProfileStore();

  const loadProfile = async () => {
    await fetchProfile();
  };

  useEffect(() => {
    loadProfile();
  }, [fetchProfile]);

  useEffect(() => {
    if (profile?.builder) {
      setFormData({
        facebook_url: profile.builder.facebook_url || "",
        linkedin_url: profile.builder.linkedin_url || "",
        youtube_url: profile.builder.youtube_url || "",
        instagram_url: profile.builder.instagram_url || ""
      });
    }
  }, [profile]);

  const toggleEdit = () => {
    if (isEditing) {
      // Reset form data to profile data when canceling
      setFormData({
        facebook_url: profile.builder.facebook_url || "",
        linkedin_url: profile.builder.linkedin_url || "",
        youtube_url: profile.builder.youtube_url || "",
        instagram_url: profile.builder.instagram_url || ""
      });
    }
    setIsEditing(!isEditing);
  };

  const handleInputChange = (key, value) => {
    setFormData(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      await updateProfile(formData);
      loadProfile(); // Fetch updated profile data after successful update
      toggleEdit();
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-6">
        <div className="w-6 h-6 border-2 border-blue-500 border-dashed rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="py-2 text-xs">
      <div className="flex items-center justify-between mb-3 border-b border-gray-400 pb-2">
        <h2 className="text-sm font-semibold">Social Media  </h2>
        <button 
          className="px-3 py-1.5 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-xs"
          onClick={toggleEdit}
        >
          Edit
        </button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {fields.map(({ key, label }, index) => (
          <div key={index} className="p-1">
            <label className="block text-xs font-medium text-gray-600">{label}</label>
            <input 
              type="text"
              value={formData[key] || ""}
              onChange={(e) => handleInputChange(key, e.target.value)}
              disabled={!isEditing}
              className={`w-full p-2 mt-1 rounded-md text-xs ${
                isEditing ? "border border-gray-300" : "border-none bg-gray-50"
              }`}
            />
          </div>
        ))}
      </div>
      
      {isEditing && (
        <div className="flex justify-end mt-3 p-2">
          <button 
            className="px-3 py-1.5 bg-gray-500 text-white rounded-md mr-2 hover:bg-gray-600 text-xs"
            onClick={toggleEdit}
          >
            Cancel
          </button>
          <button 
            className="px-3 py-1.5 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-xs"
            onClick={handleSubmit}
          >
            Save Changes
          </button>
        </div>
      )}
    </div>
  );
};

const fields = [
  { key: "facebook_url", label: "Facebook URL" },
  { key: "linkedin_url", label: "LinkedIn URL" },
  { key: "instagram_url", label: "Instagram URL" }
];

export default SocialMedia;
